<button
  type="button"
  class="chat-client-launcher btn btn-primary rounded-circle border-0 shadow d-flex align-items-center justify-content-center p-0 text-white position-fixed"
  *ngIf="!(chatClientService.panelOpen$ | async)"
  (click)="openChat($event)"
  aria-label="Open chat"
>
  <i class="bi bi-chat-dots-fill fs-4" aria-hidden="true"></i>
</button>

<ng-container *ngIf="chatClientService.panelOpen$ | async">
  <div
    class="box-chat-client position-fixed d-flex flex-column overflow-hidden bg-white rounded-4"
    role="dialog"
    aria-label="Chat"
  >
    <div class="box-chat-client-body position-relative flex-fill">
      <div
        *ngIf="chatClientService.loading$ | async"
        class="position-absolute top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center bg-white"
      >
        <div class="spinner-border text-primary" role="status"></div>
      </div>
      <iframe
        *ngIf="safeIframeUrl$ | async as chatUrl"
        class="w-100 h-100 border-0 d-block"
        [src]="chatUrl"
        title="Chat"
        [class.d-none]="chatClientService.loading$ | async"
      ></iframe>
    </div>
  </div>
</ng-container>
